import { useEffect, useState } from "react";

/** Обратный отсчёт в секундах (повторная отправка кода): `start(sec)`, `left` — сколько осталось. */
export function useCountdown() {
  const [until, setUntil] = useState(0);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (until <= now) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [until, now]);
  return {
    left: Math.max(0, Math.ceil((until - now) / 1000)),
    start: (sec: number) => {
      setNow(Date.now());
      setUntil(Date.now() + sec * 1000);
    },
  };
}
